import React, {Fragment, useContext, useEffect} from 'react';
import AppContext from '../context';
import VMContext from '../virtualMirror/context';
import content from 'Content/content.json';
import { Link, useLocation } from 'react-router-dom';
import { isIFRAMEUrl, defineFilter } from 'Root/utils';
import { imageSet } from 'Components/helper/Images';

const language = process.env.REACT_APP_LOCALE || 'en';

const InstagrameTemplate = () => {
  const appContext = useContext(AppContext);
  const vmContext = useContext(VMContext);
  // const { selectedLensType, lensIndex } = vmContext;
  const { lensCleared, InstagramBackgroundURL } = appContext;
  // const backgroundURL = InstagramBackgroundURL ? InstagramBackgroundURL : content.data.productInfo[language][selectedLensType][lensIndex]['instagram'][defineFilter()];

  useEffect(() => {
    window.console.log(VMContext);
    // window.console.log(InstagramBackgroundURL);
    // window.console.log(imageSet[backgroundURL]);
  });

  return (
    <div className="filter-wrapper">
      <div className="filter-wrapper-options">
        <ul>
          <li>
            <a href="?iframe=1&type=7&filter=1#/vm/0_-1_1" target="_blank">
              {/* <Image className="icons--main-nav" src={image} /> */}
              <Fragment>
                  <span
                    dangerouslySetInnerHTML={{ __html: "Fresh Honey" }}
                    />
              </Fragment>
              </a>
          </li>
          <li>
            <a href="?iframe=1&type=7&filter=1#/vm/1_-1_1" target="_blank">
              {/* <Image className="icons--main-nav" src={image} /> */}
              <Fragment>
                  <span
                    dangerouslySetInnerHTML={{ __html: "Fresh Grayzel" }}
                    />
              </Fragment>
              </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default InstagrameTemplate;